import React, { useEffect, useState } from "react";
import { useApi } from "utils/hooks/use-api";
import styles from "./user.module.scss";
import RefreshButton from "components/shared-ui/button/refresh-button";
import PageTitle from "components/shared-ui/pageTitle";
import Button from "components/shared-ui/button";
import { iamService } from "api/services/iam";
import { getDefaultRequestParams, getEmptyPage } from "redux/reducers/entity";
import { ITruncatedPaged } from "api/entities/page";
import { IAMUserSortField, IIAMUser } from "api/entities/iam-users";
import { routeUtils } from "utils/route-utils";
import { useNavigate } from "react-router-dom";
import { IAMUserTable } from "./user-table/user-table";
import IAMUserPanel from "./user-panel/user-panel";
import {
  IAMEntityType,
  IIAMEntityRequestParams,
} from "api/entities/iam-entity";
import { DeleteConfirmation } from "components/shared-ui/iam/dialogs/delete-confirmation";

export default function IAMUsers() {
  const [usersApi, isUsersLoading] = useApi();
  const [userPages, setUserPage] = useState<ITruncatedPaged<IIAMUser>>(
    getEmptyPage()
  );
  const [requestParams, setRequestParams] = useState<
    IIAMEntityRequestParams<IAMUserSortField>
  >({ ...getDefaultRequestParams() });

  const navigate = useNavigate();

  const fetchData = (query?: IIAMEntityRequestParams<IAMUserSortField>) => {
    const updatedQuery = { ...requestParams, ...query };

    usersApi(iamService.getUsers(updatedQuery)).then(setUserPage);
    setRequestParams(updatedQuery);
  };

  const handleDeleteUser = (UserName: string) => {
    usersApi(iamService.deleteUser(UserName)).then(() => fetchData({}));
  };

  const handleAddUserFormPanelOpen = () => {
    navigate(routeUtils.getRouteToNewIAMUser());
  };

  const handleAddUserFormPanelClose = () => {
    navigate(routeUtils.getRouteToIAMUserList());
  };

  useEffect(() => {
    fetchData(requestParams);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!userPages.marker) return;
    setRequestParams((prev) => ({ ...prev, marker: userPages.marker }));
  }, [userPages]);

  return (
    <>
      <div className={styles.header}>
        <PageTitle title={`Users`}>
          <RefreshButton onClick={() => fetchData(requestParams)} />
        </PageTitle>

        <div className={styles["action-buttons"]}>
          <Button
            testId="user-create-button"
            colors="primary"
            onClick={handleAddUserFormPanelOpen}
          >
            Create
          </Button>
        </div>
      </div>

      <IAMUserTable
        isLoading={isUsersLoading}
        page={userPages}
        isRowClickable
        hasManageColumn
        requestParams={requestParams}
        setRequestParams={fetchData}
      />
      <IAMUserPanel
        embedded={false}
        fetchUsers={() => fetchData()}
        onClose={handleAddUserFormPanelClose}
      />

      <DeleteConfirmation
        type={IAMEntityType.User}
        onDelete={handleDeleteUser}
      />
    </>
  );
}
